namespace advisorop.components.advisor {

    enum DGColumnIndex {
        HouseholdId = 0,
        GroupId,
        AccountCategory,
        AccountId,
        ModelDescription,
        AccountNumber,
        ManagerAndProduct,
        OpenDate,
        CloseDate,
        UsdMarketValue,
        SleevePercentageOfAG,
        SleevePercentageOfHH,
        GroupType
    };

    export class AccountSummaryGridController {
        accounts: Array<any>; //data for grid and pivot
        insuranceAccounts = [];
        haveInsuranceAccounts: boolean = false;
        annuityAccounts: domains.IManualAccount[] = [];
        haveAnnuityAccounts: boolean = false;
        householdId: number;
        showClosedInactive: boolean;
        hideSleeves: boolean = true;
        onItemSelected: any;
        onReady: any;
        rootLevel: string;
        dg: DevExpress.ui.dxDataGridOptions;
        dgInsuranceAccounts: DevExpress.ui.dxDataGridOptions;
        dgAnnuityAccounts: DevExpress.ui.dxDataGridOptions;
        accountGroupType: any;
        dashboardType: any;
        selrow: any;
        clel: JQuery;
        selASRow: number = -1;

        sortByField: string = "level3Caption";

        dontExpandRows = [];
        static $inject = ["advisorService", "householdApi", `acgHelper`, "advisorDashboardService"]
        constructor(
            private advisorService: services.AdvisorService,
            private hhApi: services.HouseholdApi,
            private acgs: services.AcgHelper,
            private ads: services.AdvisorDashboardService) {

            this.dg = {
                export: {
                    enabled: false,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                //height: 200,
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    //pageSize: 5,
                    enabled: false
                },
                rowAlternationEnabled: false,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                keyExpr: ['householdId', 'groupId', 'accountId', 'boModelId'],
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                sorting: {
                    mode: "single"
                },
                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                    if (e.row.rowType == "header") {
                        return;
                    }
                    var data = this.extractData(e.row);

                    let level = this.getLevel(e.row.groupIndex);
                    /*
                    if (((data.accountType != domains.InvestmentType.DIRECT_INVESTMENT && data.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT) || data.manualHoldingsExSystem)
                        && (level == "R" || level == "A" || level == "S")) {
                        e.items.push({ text: "Back Office link - Holdings", onItemClick: () => this.openBackOffice("Holdings", e.row, level) });
                        e.items.push({ text: "Back Office link - Asset Allocation", onItemClick: () => this.openBackOffice("AssetAllocation", e.row, level) });
                        if (level != "R") {
                            e.items.push({ text: "Back Office link - Activity", onItemClick: () => this.openBackOffice("Activity", e.row, level) });
                        }
                        e.items.push({ text: "Back Office link - Performance", onItemClick: () => this.openBackOffice("Performance", e.row, level) });
                        //e.items.push({ text: "Back Office link - Documents", onItemClick: () => this.openBackOffice("Documents%252FStatements", e.row, level) });
                    };
                    */
                    if (((data.accountType != domains.InvestmentType.DIRECT_INVESTMENT && data.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT)
                        || data.manualHoldingsExSystem) && (level == "H" || level == "R" || level == "A" || level == "S")) {
                        e.items.push({ text: "Back Office link - Orion Dashboard", onItemClick: () => this.openBackOffice("OrionDashboard", e.row, level) });
                    }
                    if (level == "R") {
                        e.items.push({ text: "Rename Account Group", onItemClick: () => this.rename(e.row, level, this.accounts) });
                    }
                    if (level == "A") {
                        e.items.push({ text: "Rename Account", onItemClick: () => this.rename(e.row, level, this.accounts) });
                        if (data.accountType == domains.InvestmentType.CUSTODIAN_ACCOUNT) {
                            e.items.push({ text: "Modify Product Description", onItemClick: () => this.modifyProductDescription(e.row, this.accounts) });
                        }
                        e.items.push({ text: "Account Summary", onItemClick: () => location.href = `/advisor/accountsummary/${data.accountId}` });
                    }

                    // RTG/ADG dashboard
                    //if (this.rootLevel != "R" && data.groupType == 1) {
                    //    e.items.push({ text: "RTG Dashboard", onItemClick: () => location.href = `/advisor/advisorrtgdashboard/${data.groupId}` });
                    //} else if (this.rootLevel != "R" && data.groupType == 2) {
                    //    var hasManualAccounts = this.accounts.filter((v) => { return v.groupId == data.groupId && v.advisoryFirmMgtRole > 0 }).length > 0;
                    //    //if (!hasManualAccounts) {
                    //        e.items.push({ text: "ADG Dashboard", onItemClick: () => location.href = `/advisor/advisoradgdashboard/${data.groupId}` });
                    //    //}
                    //}

                    // Modify account RTG
                    //if (this.rootLevel == "R" && data.groupType == 1) {
                    //    e.items.push({ text: "Modify RTG", onItemClick: () => location.href = `/advisor/assignaccountrtg/${data.accountId}` });
                    //}
                },
                onCellPrepared: (e: any) => {
                    //console.log("Cell prepared: ", e);
                    if (e.column.command === "expand" && e.row) {

                        const dontExpand = ((e.data && e.data.collapsedItems && e.data.collapsedItems.length <= 1) || this.hideSleeves == true);

                        // commenting this out to allow users to expand/contract the account category groupings
                        //if (this.rootLevel === "R" && e.row.groupIndex === 1) {
                        //    e.cellElement.html("");
                        //} else if (this.rootLevel !== "R" && e.row.groupIndex === 2) {
                        //    e.cellElement.html("");
                        //} else
                        if (this.rootLevel === "R" && e.row.groupIndex === 2) {
                            // console.log("onCellPrepared RTG: ", e);
                            const ind = this.dontExpandRows.indexOf(e.key[2]);
                            if (dontExpand) {
                                e.cellElement.html("");
                                if (ind < 0) this.dontExpandRows.push(e.key[2]);
                            } else if (!dontExpand && ind >= 0) {
                                this.dontExpandRows.splice(ind, 1);
                            }
                        } else if (this.rootLevel !== "R" && e.row.groupIndex === 3) {
                            const ind = this.dontExpandRows.indexOf(e.key[3]);
                            // console.log("onCellPrepared HH: ", e, ind, dontExpand);
                            if (dontExpand) {
                                e.cellElement.html("");
                                if (ind < 0) this.dontExpandRows.push(e.key[3]);
                            } else if (!dontExpand && ind >= 0) {
                                this.dontExpandRows.splice(ind, 1);
                            }
                        }
                    }

                    if (e.rowType === "group" && e.summaryItems.length === 1) {
                        //column indexes
                        //HouseholdId = 0,
                        //GroupId,
                        //ProductType,
                        //AccountId,
                        //ModelDescription,
                        //AccountNumber,
                        //ManagerAndProduct,
                        //OpenDate,
                        //CloseDate,
                        //UsdMarketValue,
                        //SleevePercentageOfAG,
                        //SleevePercentageOfHH,
                        //GroupType

                        if (
                            // Do not show accountNumber, managerAndProduct, openDate or closeDate values above the account level
                            (this.rootLevel !== "R" && e.row.groupIndex < 3 && (e.columnIndex === DGColumnIndex.AccountNumber || e.columnIndex === DGColumnIndex.ManagerAndProduct || e.columnIndex === DGColumnIndex.OpenDate || (this.showClosedInactive === true && e.columnIndex === DGColumnIndex.CloseDate)))

                            || (this.rootLevel === "R" && e.row.groupIndex < 2 && (e.columnIndex === DGColumnIndex.AccountNumber - 1 || e.columnIndex === DGColumnIndex.ManagerAndProduct - 1 || e.columnIndex === DGColumnIndex.OpenDate - 1 || (this.showClosedInactive === true && e.columnIndex === DGColumnIndex.CloseDate - 1)))

                            // Do not show % of Risk Group grand total at topmost HH level
                            || (this.rootLevel !== "R" && e.row.groupIndex === 0 && ((this.showClosedInactive === true && e.columnIndex === DGColumnIndex.SleevePercentageOfAG) || (this.showClosedInactive === false && e.columnIndex === DGColumnIndex.SleevePercentageOfAG - 1)))

                            // Do not show any HH level totals in the ADG dashboard
                            || (this.rootLevel !== "R" && e.row.groupIndex === 0 && this.accountGroupType == 2 && (e.columnIndex === DGColumnIndex.SleevePercentageOfAG || e.columnIndex === DGColumnIndex.UsdMarketValue))

                        )
                            e.cellElement.text("");

                        if (this.showClosedInactive === true) {
                            // Do not show close date at account level unless all sleeves in account are closed
                            if (((this.rootLevel !== "R" && e.columnIndex === DGColumnIndex.CloseDate && e.row.groupIndex === 3)
                                || (this.rootLevel === "R" && e.columnIndex === DGColumnIndex.CloseDate - 1 && e.row.groupIndex === 2))
                                && (e.data.collapsedItems != null && (!e.data.collapsedItems.every(o => o.closeDate != null))
                                    || e.data.items != null && (!e.data.items.every(o => o.closeDate != null))))
                                e.cellElement.text("");
                        }
                    }
                    else if (e.rowType === "data") {
                        // Do not show managerAndProduct or accountNumber at the sleeve level. Show openDate and closeDate at the sleeve level.
                        if ((this.rootLevel !== "R" && (e.columnIndex === DGColumnIndex.ManagerAndProduct || e.columnIndex === DGColumnIndex.AccountNumber))
                            || (this.rootLevel === "R" && (e.columnIndex === DGColumnIndex.ManagerAndProduct - 1 || e.columnIndex === DGColumnIndex.AccountNumber - 1))) {
                            e.cellElement.text("");
                        }
                        if (this.rootLevel != "R") {
                            if (e.columnIndex == DGColumnIndex.ModelDescription) {
                                e.cellElement.addClass("grL4ColPad");
                            }
                            if (e.columnIndex >= DGColumnIndex.ModelDescription) {
                                e.cellElement.addClass("grL4Col");
                            }
                        } else {
                            if (e.columnIndex == DGColumnIndex.ModelDescription - 1) {
                                e.cellElement.addClass("grL4ColPad");
                            }
                            if (e.columnIndex >= (DGColumnIndex.ModelDescription - 1)) {
                                e.cellElement.addClass("grL4Col");
                            }
                        }
                    }
                },
                grouping: {
                    autoExpandAll: false,
                    allowCollapsing: true,
                    //expandMode: "rowClick"
                },
                columns: [
                    {
                        dataField: "householdId",
                        caption: "Household",
                        groupIndex: 0,
                        autoExpandGroup: true,
                        //showWhenGrouped: true,
                        //visible: this.rootLevel === "R" ? false: true,
                        groupCellTemplate: (groupCell, info) => {
                            //console.log(groupCell);
                            //console.log(info);
                            var item = this.extractData(info);
                            $("<span>").html(item.householdName).appendTo(groupCell);

                            this.clel = $(groupCell).next("td");
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement; //.addClass("grL1");

                            if (item.advisoryFirmMgtRole == 0 && item.groupType == 3) {
                                $(row).addClass("grL1Err");
                            }
                            else {
                                $(row).addClass("grL1");
                            }
                        }

                    },
                    {
                        dataField: "groupId",
                        caption: "Group",
                        sortIndex: 0,
                        sortOrder: "asc",
                        calculateGroupValue: (rowData) => {  // used for sorting
                            return rowData.groupName;
                        },
                        groupIndex: 1,
                        autoExpandGroup: true,

                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            //var grName = item.groupName;
                            //var description = grName;
                            //if (item.groupType == 1 && grName.lastIndexOf("[") >= 0) {
                            //    description = grName.substring(grName.lastIndexOf("[") + 1, grName.lastIndexOf("]"));
                            //    $("<span>").html(description + " (" + item.level2Caption + ")").appendTo(groupCell);
                            //} else {
                            //    $("<span>").html(description).appendTo(groupCell);
                            //}
                            $("<span>").html(item.groupDescription).appendTo(groupCell);


                            if (this.rootLevel != "R" && item.groupType == 1) {
                                var lnk = $(`<a href="/advisor/advisorrtgdashboard/${item.groupId}" class="btn btn-info btn-xs m-l-sm">`).html("RTG Dashboard"); //<i class="fa fa-dashboard"> </i>
                                lnk.appendTo(groupCell);
                            }
                            else if (this.rootLevel != "R" && item.groupType == 2) {
                                var hasManualAccounts = this.accounts.filter((v) => { return v.groupId == item.groupId && v.advisoryFirmMgtRole > 0 }).length > 0;
                                //if (!hasManualAccounts) {
                                var lnk = $(`<a href="/advisor/advisoradgdashboard/${item.groupId}" class="btn btn-info btn-xs m-l-sm">`).html("ADG Dashboard"); //<i class="fa fa-dashboard"> </i>
                                lnk.appendTo(groupCell);
                                //}
                                //else {
                                //    var lnk = $(`<button type="button" class="btn btn-default btn-xs m-l-sm" disabled>`).html("ADG Dashboard"); //<i class="fa fa-dashboard"> </i>
                                //    lnk.appendTo(groupCell);
                                //}
                            }

                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement; //.addClass("grL1");

                            if (item.advisoryFirmMgtRole == 0 && item.groupType == 3) {
                                $(row).addClass("grL2Err");
                            }
                            else {
                                $(row).addClass("grL2");
                            }
                        }
                    },
                    {
                        dataField: "accountCategory",
                        caption: "AccountCategory",
                        groupIndex: 2,
                        sortIndex: 0,
                        sortOrder: "desc",
                        autoExpandGroup: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            $("<span>").html(item.accountCategory).appendTo(groupCell);
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement;
                            $(row).addClass("grL2");
                        }
                    },
                    {
                        dataField: "accountId",
                        cssClass: "advisorop-gridcol",
                        caption: "Account",
                        groupIndex: 3,
                        calculateDisplayValue: (rowDatas) => {
                            let rowData = rowDatas;

                            if (rowDatas.items) {
                                rowData = rowDatas.items[0];
                            }

                            let keySortByField = this.acgs.calcSortableFieldValue(rowData, this.sortByField, this.accounts);

                            const sortExpr = `${keySortByField}-${rowData.level3Caption}-${rowData.accountId}`;

                            return sortExpr.trim();
                        },
                        groupCellTemplate: (groupCell, info) => {
                            //console.log(info);
                            var item = this.extractData(info);
                            $("<span>").html(`${item.level3Caption}`).appendTo(groupCell);
                            //if (this.rootLevel == "R" && item.groupType == 1) {
                            //    let lnk = $(`<a href="/advisor/assignaccountrtg/${item.accountId}" class="btn btn-default btn-xs m-l-sm">`).html("Modify RTG"); //<i class="fa fa-dashboard"> </i>
                            //    lnk.appendTo(groupCell);
                            //}
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement; //.addClass("grL1");
                            if (item.advisoryFirmMgtRole == 0 && item.groupType == 3) {
                                $(row).addClass("grL3Err");
                            }
                            else {
                                $(row).addClass("grL3");
                            }
                        }
                    },
                    { dataField: "modelDescription", caption: "Account/Model", cssClass: "advisorop-gridcol", width: 200, allowReordering: false },
                    { dataField: "accountNumber", caption: "Account #", cssClass: "advisorop-gridcol", width: 100, allowReordering: false },
                    { dataField: "managerAndProduct", caption: "Product", cssClass: "advisorop-gridcol", width: 350, allowReordering: false, allowSorting: true },
                    { dataField: "openDate", caption: "Start Date", headerCellTemplate: (h, info) => { $(h).attr("title", "Sourced from Orion").append($("<span>").text(info.column.caption || "")); }, cssClass: "advisorop-gridcol", width: 70, allowReordering: false, allowSorting: false, dataType: "date" },
                    { dataField: "closeDate", caption: "Close Date", cssClass: "advisorop-gridcol", width: 70, visible: false, allowReordering: false, allowSorting: false },
                    { dataField: "usdMarketValue", caption: "Market Value", cssClass: "advisorop-gridcol", format: "currency", allowReordering: false, allowSorting: true, },
                    { dataField: "sleevePercentageOfAG", caption: "% of Group", cssClass: "advisorop-gridcol", dataType: "number", format: { type: "percent", precision: 2 }, allowReordering: false, allowSorting: true },
                    { dataField: "sleevePercentageOfHH", caption: "% of Household", cssClass: "advisorop-gridcol", dataType: "number", format: { type: "percent", precision: 2 }, allowReordering: false, allowSorting: true },
                    { dataField: "groupType", visible: false }
                ],
                sortByGroupSummaryInfo: [
                    { summaryItem: "groupType", sortOrder: "asc" }
                ],
                summary: {
                    groupItems: [
                        {
                            column: "usdMarketValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                            //customizeText: function (obj) {
                            //    console.log(obj);                                
                            //    return $("<div>").html(obj.valueText).addClass("pull-right").text();
                            //}          
                            //showInGroupFooter: true,                            
                        },
                        {
                            column: "managerAndProduct",
                            alignByColumn: true,
                            summaryType: "min",
                            displayFormat: "{0}",
                        },
                        {
                            column: "accountNumber",
                            alignByColumn: true,
                            summaryType: "min",
                            displayFormat: "{0}",
                        },
                        {
                            column: "openDate",
                            alignByColumn: true,
                            summaryType: "min",
                            displayFormat: "{0}",
                        },
                        {
                            column: "closeDate",
                            alignByColumn: true,
                            summaryType: "max",
                            displayFormat: "{0}",
                        },
                        {
                            column: "sleevePercentageOfAG",
                            alignByColumn: true,
                            summaryType: "custom",
                            displayFormat: "{0}",
                            valueFormat: {
                                type: "percent",
                                precision: 2
                            },
                        },
                        {
                            column: "sleevePercentageOfHH",
                            alignByColumn: true,
                            summaryType: "custom",
                            displayFormat: "{0}",
                            valueFormat: {
                                type: "percent",
                                precision: 2
                            },
                        },
                        {
                            column: "groupType",
                            showInColumn: "false",
                            summaryType: "max"
                        }
                    ],
                    calculateCustomSummary: (e) => {
                        switch (e.summaryProcess) {
                            case "start":
                                e.totalValue = 0;
                                break;
                            case "calculate":
                                e.totalValue += e.value;
                                break;
                            case "finalize":
                                var roundedValue = e.totalValue * 10000;
                                var roundedValue2 = Math.round(roundedValue);
                                e.totalValue = roundedValue2 / 10000;
                        }
                    }
                },
                onRowPrepared: (e) => {
                    //console.log("Row prepared: ", e.key);
                    if (e.rowIndex == this.selASRow) {
                        var r = $(e.rowElement);
                        r.addClass("acsrow");
                    }
                },
                onCellClick: (e) => {
                    //console.log("Cell clicked: ", e.key, e.column);
                    if (e.rowType === "header") {

                        //disable sorting if column is not sortable
                        if (!e.column.allowSorting) {
                            return;
                        }


                        const ind = 2; //  this.rootLevel == "R" ? 1 : 2;
                        this.sortByField = this.acgs.mapSummaryGridSortColumn(e.column.dataField);

                        const sortOrder = e.component.columnOption(ind/*e.columnIndex*/, "sortOrder") === "desc" ? "asc" : "desc";

                        //console.log(`Sort column ${e.component.columnOption(ind, "dataField")} ${sortOrder} over ${e.columnIndex}`);

                        e.component.columnOption(ind, "sortOrder", sortOrder);
                        e.component.columnOption(e.columnIndex, "sortOrder", sortOrder);
                    }
                },
                onRowExpanding: (e: any) => {
                    //                    if (this.hideSleeves == true) {
                    //                        e.cancel = true;
                    //                    } else if (this.rootLevel === "R" && e.key.length === 2) {
                    if (this.rootLevel === "R" && (e.key.length === 3)) {
                        e.cancel = this.dontExpandRows.indexOf(e.key[2]) >= 0;
                    } else if (this.rootLevel !== "R" && (e.key.length === 4)) {
                        e.cancel = this.dontExpandRows.indexOf(e.key[3]) >= 0;
                    }
                },
                // commenting this out to allow the users to expand/collapse account category groupings
                //onRowCollapsing: (e: any) => {
                //    //console.log("THE KEY IS", e.key);
                //    e.cancel = (this.rootLevel === "R" && e.key.length === 2) || (this.rootLevel !== "R" && e.key.length === 3);
                //},
                onRowClick: (e) => {
                    //console.log(`Summary grid row click key: `, e.key);
                    //console.log(`Summary grid row click index: `, e.rowIndex);

                    var maxDepth = 5;
                    var item = e;
                    var groupIndex = e.groupIndex;

                    if (this.selASRow == e.rowIndex)
                        return;

                    e.component.deselectRows(e.component.getKeyByRowIndex(this.selASRow))

                    this.selASRow = e.rowIndex;

                    var r = $(e.rowElement);
                    $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                        $(elm).removeClass("acsrow");
                    });
                    r.addClass("acsrow");

                    let data = this.extractData(e);

                    let level = this.getLevel(groupIndex)

                    if (level != "AG") {
                        let additionalData = this.calculateAdditionalData(level, data);
                        this.onItemSelected({ item: data, level: level, additionalData: additionalData });
                    } else {
                        this.onItemSelected({ item: data, level: level, additionalData: null });
                    }
                },
                onContentReady: (e) => {

                    // console.log("account-summary-grid onContentReady");
                    if (this.rootLevel == "R") {
                        e.component.columnOption("householdId", "visible", false);
                        e.component.columnOption("householdId", "groupIndex", undefined);
                        e.component.columnOption("groupId", "groupIndex", 0);
                        e.component.columnOption("accountCategory", "groupIndex", 1);
                        e.component.columnOption("accountId", "groupIndex", 2);
                    }

                    // Deselect all rows on initial content ready
                    $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                        $(elm).removeClass("acsrow");
                    });

                    // select first row
                    if (this.accounts && this.accounts.length > 0) {
                        let topRowInd: number = -1;
                        if (this.rootLevel === "R") {
                            topRowInd = e.component.getRowIndexByKey([+this.accounts[0].groupId]);
                        } else {
                            topRowInd = e.component.getRowIndexByKey([+this.householdId]);
                        }

                        if (topRowInd >= 0) {
                            const topRowEl = e.component.getRowElement(topRowInd);

                            const rowOptions = topRowEl.data().options;

                            let level = this.getLevel(rowOptions.groupIndex);

                            let data = this.extractData(rowOptions);

                            $(topRowEl).addClass("acsrow");

                            // we need this to prevent duplicate event emiting
                            if (this.selASRow != -1 && this.selASRow != topRowInd) {
                                this.selASRow = topRowInd;

                                //console.log("ASG: emmiting event onItemSelected from OnContentReady, selASRow:", this.selASRow);
                                this.onItemSelected({ item: data, level: level, additionalData: this.calculateAdditionalData(level, data) });
                            }
                        }
                    }

                    //in case of RTG we need to show Summary on the top level node
                    if (this.clel && this.accountGroupType != 1) {
                        this.clel.text("");
                    }
                    // console.log("dont expand rows: ", this.dontExpandRows);
                    if (this.accountGroupType == 2) {
                        e.component.columnOption("sleevePercentageOfHH", "visible", false);
                    } else {
                        e.component.columnOption("sleevePercentageOfHH", "visible", true);
                    }

                    // We always show closed / inactive in RTG dash because it inclused performance of accounts
                    if (this.showClosedInactive === true) {
                        e.component.columnOption("closeDate", "visible", true);
                    } else {
                        e.component.columnOption("closeDate", "visible", false);
                    }
                }
            };


            // annuity accounts 
            this.dgAnnuityAccounts = {
                export: {
                    enabled: true,
                    fileName: "AnnuityAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.annuityAccounts"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    enabled: false
                },
                rowAlternationEnabled: true,
                showBorders: false,
                showRowLines: false,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                    if (e.row.rowType != "data") {
                        return;
                    }
                    //console.log("E IS:", e);
                    e.items.push({ text: "Rename Account", onItemClick: () => this.rename(e.row, "A", this.annuityAccounts) });
                    e.items.push({ text: "Account Summary", onItemClick: () => location.href = `/advisor/accountsummary/${e.row.data.accountId}` });
                },
                grouping: {
                    autoExpandAll: false,
                    allowCollapsing: true
                },
                columns: [
                    { dataField: "investors", caption: "Investors" },
                    {
                        dataField: "groupName",
                        caption: "Group",
                        groupIndex: 0,
                        autoExpandGroup: true,
                        visible: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            $("<span>").html(`${item.groupName}`).appendTo(groupCell);
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement;
                            $(row).addClass("grL1");
                        }
                    },

                    // move to template if you want to use this
                    //<div data - options="dxTemplate: {name: 'colAccount'}" >
                    //{{ item.data.accountName }} { { item.data.policyNumber } }
                    //<!--< a class="btn btn-default btn-xs" tooltip - placement="right" ng - click="Assign HH" >& nbsp; <i class="fa fa-dashboard" > </i></a > -->
                    //</div>
                    { dataField: "accountName", caption: "Account Name" },
                    //{ dataField: "policy", caption: "Policy Type" },
                    //{ dataField: "policyCompany", caption: "Company" },
                    //{ dataField: "productDescription", caption: "Product" },
                    { dataField: "accountNumber", caption: "Policy Number", width: 100, sortIndex: 0, sortOrder: "asc" },
                    { dataField: "managerProduct", caption: "Product" },
                    { dataField: "state", caption: "State" },
                    { dataField: "issueDate", caption: "Issue Date", dataType: "date", alignment: "center" },
                    { dataField: "outOfSurrenderDate", caption: "Out of Surrender Date", dataType: "date", alignment: "center" },
                    { dataField: "initialPremium", caption: "Initial Premium", format: "currency", width: 84 },
                    { dataField: "incomeValue", caption: "Income Value", format: "currency", width: 84 },
                    { dataField: "cashValue", caption: "Cash Value", format: "currency", width: 84 },
                    { dataField: "currentValuesUpdatedOn", caption: "Values Updated On", dataType: "date", alignment: "center" },
                    { dataField: "annuityTaxQualification", caption: "Tax Qualification" },
                    {
                        dataField: "annuityAccountStatus", caption: "Status", calculateDisplayValue: (rowDatas) => {
                            var status = (rowDatas as domains.IManualAccount).annuityAccountStatus;
                            if (status == null || status == undefined) {
                                return "Status not set"
                            }
                            switch (status) {
                                case domains.AnnuityAccountStatus.ANNUITIZED:
                                    return "Annuitized";
                                case domains.AnnuityAccountStatus.CANCELED:
                                    return "Canceled";
                                case domains.AnnuityAccountStatus.CLOSED:
                                    return "Closed";
                                case domains.AnnuityAccountStatus.DEATH_CLAIM_PAID:
                                    return "Death Claim Paid";
                                case domains.AnnuityAccountStatus.FULLY_PAID_OUT:
                                    return "Fully Paid Out";
                                case domains.AnnuityAccountStatus.OPEN:
                                    return "Open";
                                case domains.AnnuityAccountStatus.RETURNED:
                                    return "Returned";
                                case domains.AnnuityAccountStatus.SURRENDERED:
                                    return "Surrendered";
                                default:
                                    return "Unknown";
                            }
                        },
                        alignment: "left",
                    }
                ],
                summary: {
                    groupItems: [
                        {
                            column: "incomeValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        },
                        {
                            column: "cashValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        },
                    ]
                }
            };

            // insurance accounts 
            this.dgInsuranceAccounts = {
                export: {
                    enabled: true,
                    fileName: "InsuranceAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.insuranceAccounts"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    enabled: false
                },
                rowAlternationEnabled: true,
                showBorders: false,
                showRowLines: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                    if (e.row.rowType != "data") {
                        return;
                    }
                    //console.log("E IS:", e);
                    e.items.push({ text: "Rename Account", onItemClick: () => this.rename(e.row, "A", this.insuranceAccounts) });
                    e.items.push({ text: "Account Summary", onItemClick: () => location.href = `/advisor/accountsummary/${e.row.data.accountId}` });
                },
                grouping: {
                    autoExpandAll: false,
                    allowCollapsing: true
                },
                columns: [
                    {
                        dataField: "groupName",
                        caption: "Group",
                        groupIndex: 0,
                        autoExpandGroup: true,
                        visible: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            $("<span>").html(`${item.groupName}`).appendTo(groupCell);
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement;
                            $(row).addClass("grL1");
                        }
                    },
                    // move to template if you want to use this
                    //<div data - options="dxTemplate: {name: 'colAccount'}" >
                    //{{ item.data.accountName }} { { item.data.policyNumber } }
                    //<!--< a class="btn btn-default btn-xs" tooltip - placement="right" ng - click="Assign HH" >& nbsp; <i class="fa fa-dashboard" > </i></a > -->
                    //</div>
                    { dataField: "accountName", caption: "Account Name" },
                    //{ dataField: "policy", caption: "Policy Type" },
                    //{ dataField: "policyCompany", caption: "Company" },
                    //{ dataField: "productDescription", caption: "Product" },
                    { dataField: "accountNumber", caption: "Policy Number", width: 100 },
                    { dataField: "managerProduct", caption: "Product" },
                    { dataField: "benefit", caption: "Benefit", format: "currency", width: 84 },
                    { dataField: "cashValue", caption: "Cash Value", format: "currency", width: 84 }
                ],
                summary: {
                    groupItems: [
                        {
                            column: "cashValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        },
                        {
                            column: "benefit",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        }
                    ]
                }
            };

        } // constructor

        // helper methods
        formatZeroDpCurrency(num: number): string {
            var ret = '$' + num.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            return ret;
        }

        calculateAdditionalData = (level: string, data: any): string => {
            if (level == "H") {
                return data.householdName + " - Household Level";
            }
            else if (level == "R") {
                return data.groupDescription + " - Account Group";
            }
            else if (level == "A") {
                var acctValue = this.accounts.filter(item => item.accountId === data.accountId && item.groupId === data.groupId)
                    .reduce((acctValue, current) => acctValue + current.usdMarketValue, 0);

                return data.level3Caption + ` (${data.accountNumber} ${this.formatZeroDpCurrency(acctValue)})`;
            }
            // Sleeve
            return data.level3Caption + ` (${data.accountNumber}) - ` + data.modelDescription + ` (${this.formatZeroDpCurrency(data.usdMarketValue)})`;
        }

        extractData(e, print = false): any {
            var maxDepth = 5;
            var item = e;

            for (var d = 0; d < maxDepth; d++) {
                if (item.rowType === "group" && d == 0) {
                    item = item.data.items ? item.data.items[0] : item.data.collapsedItems[0];
                    //if (print) console.log(`#1 New item `, item);
                }
                else if ((item.items || item.collapsedItems) && d > 0) {
                    item = item.items ? item.items[0] : item.collapsedItems[0];
                    //if (print) console.log(`#2 New item `, item);
                }
                else if (!(item.items || item.collapsedItems) && d > 0) {
                    //if (print) console.log(`#3 returning item `, item);
                    return item;
                }
                else if (item.rowType === "data") {
                    //if (print) console.log(`#4 returning item `, item.data);
                    return item.data;
                }
            }
        };

        getLevel(groupIndex: number): string {
            if (groupIndex != undefined) {
                if (this.rootLevel === "R")
                    groupIndex = groupIndex + 1;

                if (groupIndex == 0) return "H";
                else if (groupIndex == 1) return "R";
                else if (groupIndex == 2) return "AG";
                else if (groupIndex == 3) return "A";
            }
            return "S";
        }

        rename(e, level: string, accountList: any[]) {
            let data: domains.IHDAccount = this.extractData(e);
            if (level == "R") {

                var description = data.groupName;
                //if (data.groupType == 1 && data.groupName.lastIndexOf("[") >= 0)
                //    description = data.groupName.substring(data.groupName.lastIndexOf("[") + 1, data.groupName.lastIndexOf("]"));
                if (data.groupType == domains.AccountGroupType.RTG && data.groupName.lastIndexOf("[") >= 0)
                    description = data.groupName.substring(0, data.groupName.lastIndexOf("["));

                const oldGroupName = data.groupName;
                const oldGroupDescription = data.groupDescription;

                var groupName = prompt("Enter new group name", description);
                //groupName = this.advisorService.replaceSlashes(groupName);

                var groupDescription = groupName;

                if (groupName && groupName.length > 0) {
                    if (data.groupType == domains.AccountGroupType.RTG) {
                        // only for RTG groups...
                        if (data.groupDescription.lastIndexOf("(") > 0)
                            groupDescription = groupName + ' ' + data.groupDescription.substring(data.groupDescription.lastIndexOf("("));
                        //groupName = "[" + groupName + "]";
                        //groupName = groupName + " []";
                    }

                    accountList.filter(f => f.groupId == data.groupId)
                        .forEach(v => {
                            v.groupName = groupName;
                            v.groupDescription = groupDescription;
                        });

                    this.refreshGrids();

                    this.advisorService.renameAccountGroup(data.groupId, groupName)
                        .then(response => {
                        }, err => {
                            data.groupName = groupName;
                            data.groupDescription = groupDescription;
                            //this.refreshGrids();
                        }).finally(() => {
                            this.refreshGrids();
                        })
                }
            }
            else if (level == "A") {
                var accountName = prompt("Enter new account name", data.accountName);
                if (accountName && accountName.length > 0) {
                    //accountName = this.advisorService.replaceSlashes(accountName);
                    this.advisorService.renameAccount(data.accountId, accountName)
                        .then(response => {
                            accountList.filter(f => f.accountId == data.accountId).forEach(v => { v.accountName = accountName; v.level3Caption = accountName; });
                            this.refreshGrids();
                        //    $("#dgHouseholds").dxDataGrid("instance").refresh();
                        //    if (this.haveInsuranceAccounts) {
                        //        $("#dgInsuranceAccounts").dxDataGrid("instance").refresh();
                        //    }
                        //    if (this.haveAnnuityAccounts) {
                        //        $("#dgAnnuityAccounts").dxDataGrid("instance").refresh();
                        //    }
                        });
                }
            }
        };

        modifyProductDescription(e, accountList: any[]) {
            let data: domains.IHDAccount = this.extractData(e);
            var pd = prompt("Enter new product description", data.managerAndProduct);
            if (pd && pd.length > 0) {
                //pd = this.advisorService.replaceSlashes(pd);
                this.advisorService.modifyProductDescription(data.accountId, pd)
                    .then(response => {
                        accountList.filter(f => f.accountId == data.accountId).forEach(v => v.managerAndProduct = pd);
                        this.refreshGrids();
                    //    $("#dgHouseholds").dxDataGrid("instance").refresh();
                    //    if (this.haveInsuranceAccounts) {
                    //        $("#dgInsuranceAccounts").dxDataGrid("instance").refresh();
                    //    }
                    //    if (this.haveAnnuityAccounts) {
                    //        $("#dgInsuranceAccounts").dxDataGrid("instance").refresh();
                    //    }
                    });
            }
        };

        refreshGrids() {
            $("#dgHouseholds").dxDataGrid("instance").refresh();
            if (this.haveInsuranceAccounts) {
                $("#dgInsuranceAccounts").dxDataGrid("instance").refresh();
            }
            if (this.haveAnnuityAccounts) {
                $("#dgAnnuityAccounts").dxDataGrid("instance").refresh();
            }
        }

        openBackOffice(report: string, e: any, level: string): void {

            let data = this.extractData(e);
            console.log('Data from grid:', data);
            let entityId = data.accountId; // default to accountId
            if (level == "H") {
                entityId = this.householdId; // for H level we use householdId
            } else if (level == "R") {
                entityId = data.groupId; // for R level we use groupId
            }

            this.ads.calculateBackOfficeParamsAsync(level, entityId).then(params => {
                this.ads.openBackOfficeReport(report, params);
            });

        }

        $onInit(): void {
            var component = this;
            this.onReady({ component });
        }

        // TODO: we need to remove this method from here !!!!! instead of this emmit event !
        loadHDAccounts(): void {

            const dg = DevExpress.ui.dxDataGrid.getInstance($("#dgHouseholds")) as DevExpress.ui.dxDataGrid;
            dg.beginCustomLoading("Loading data...");
            // this.advisorService.getHDAccounts(this.accountGroupType, this.householdId, this.showClosedInactive)
            this.hhApi.getAccountGroupsSummary(this.householdId, this.accountGroupType, this.showClosedInactive)
                .then(response => {
                    dg.endCustomLoading();
                    this.accounts = response.data.gridData;

                    //let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgHouseholds')) as DevExpress.ui.dxDataGrid;
                    //if (dg) {
                    //   if (this.showClosedInactive == true)
                    //       dg.columnOption("closeDate", "visible", true);
                    //   else
                    //       dg.columnOption("closeDate", "visible", false);
                    //   dg.refresh();
                    //}
                    this.insuranceAccounts = response.data.insuranceAccounts ?? []
                    this.annuityAccounts = response.data.annuityAccounts ?? [];
                },
                    err => { dg.endCustomLoading(); toastr.error("Unexpected error during account loading... ERROR " + err.status + " " + err.data); },
                    () => dg.endCustomLoading());
        };

        onChangedOptionForShowClosedInactive(): void {
            //console.log("BBB HOUSEHOLD IS:", this.householdId);
            if (this.householdId) {
                this.accounts = null;

                // TODO: emmit event here !!!!
                this.loadHDAccounts();
            }
        }

        onChangedOptionForHideSleeves(): void {
            // Collapse any open account levels
            const dg = DevExpress.ui.dxDataGrid.getInstance($('#dgHouseholds')) as DevExpress.ui.dxDataGrid;
            if (this.hideSleeves == true) {
                if (dg) {
                    let vr = dg.getVisibleRows();
                    for (let i = 0; i < vr.length; i++) {
                        var groupIndex = vr[i].groupIndex
                        let level = this.getLevel(groupIndex)
                        if (level == "A") {
                            dg.collapseRow(vr[i].key);
                        }
                    }
                }
            }
            // console.log(`ASG: refreshing dg...`);
            dg.refresh();
        }

        isHouseholdDashboard(): boolean {
            return (this.dashboardType == domains.DashboardType.HOUSEHOLD);
        }

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "insuranceAccounts") {
                    if (this.insuranceAccounts && this.insuranceAccounts.length > 0)
                        this.haveInsuranceAccounts = true;
                    else
                        this.haveInsuranceAccounts = false;
                } else if (key === "annuityAccounts") {
                    if (this.annuityAccounts && this.annuityAccounts.length > 0)
                        this.haveAnnuityAccounts = true;
                    else
                        this.haveAnnuityAccounts = false;
                } else if (key === `accounts` && this.accounts) {
                    this.selASRow = -1;
                }
            }
        };

    }



    class AccountSummaryGrid implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accounts: "<",
                insuranceAccounts: "<",
                annuityAccounts: "<",
                householdId: "<",
                accountGroupType: "<",
                dashboardType: "<",
                showClosedInactive: "=",
                onItemSelected: "&",
                onReady: "&",
                rootLevel: "@"
            };
            this.controller = AccountSummaryGridController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/account-summary-grid.html";
        }
    }
    angular.module(Constants.APP).component("accountSummaryGrid", new AccountSummaryGrid());

}